<template>
    <div class="row mb-4">
        <div class="col-sm-4">
            <slot name="header">
                <div>
                    <h5>
                        {{ title }}
                    </h5>
                    <p class="text-muted">
                        {{ description }}
                    </p>
                </div>
            </slot>
        </div>
        <div class="col-sm-7">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'description']
}
</script>

<style scoped>

</style>
